import { render, staticRenderFns } from "./StatisticsItem.vue?vue&type=template&id=5a715394&scoped=true&"
import script from "./StatisticsItem.vue?vue&type=script&lang=js&"
export * from "./StatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsItem.vue?vue&type=style&index=0&id=5a715394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a715394",
  null
  
)

export default component.exports